import type { OctFlash2026Variant } from '~/features/promotions/constants/oct-flash-2026';
import {
  getOctFlash2026SlideKey,
  getOctFlash2026Variant,
  resolveOctFlash2026Variant,
} from '~/features/promotions/utils/get-oct-flash-2026-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

export const OCT_FLASH_2026_CAMPAIGN_ID = 'oct-flash-2026';

export const octFlash2026CampaignCore: Pick<
  PromoCampaignSurfaceRenderers<OctFlash2026Variant>,
  'id' | 'getSlideKey' | 'matches' | 'isGateReady' | 'resolve'
> = {
  id: OCT_FLASH_2026_CAMPAIGN_ID,
  getSlideKey: ({ resolved }) => getOctFlash2026SlideKey(resolved),
  matches: ({ forcedPromotionId, promotionId }) =>
    getOctFlash2026Variant(forcedPromotionId) != null || getOctFlash2026Variant(promotionId) != null,
  isGateReady: ({ forcedPromotionId, promotionFetched }) =>
    getOctFlash2026Variant(forcedPromotionId) != null || promotionFetched,
  resolve: ({ forcedPromotionId, promotionId }) => resolveOctFlash2026Variant(forcedPromotionId, promotionId),
};
